import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Row, Button, Field, Label, ToolTip, CollapsiblePanel, Paragraph, ReadOnlyText, Tip, Blocker }  from '../../generic'
import TextInput from '../../generic/fields/TextInput'
import RadioInput from '../../generic/fields/RadioInput'
import kit from '../../../images/OTT_Kit.jpg';
import { sharePreferences} from '../../../helpers/enums';
import CopyToClipboardButton from '../../CopyToClipboardButton';
import styled from 'styled-components';
import * as variables from '../../../styles/variables'
import WebMailHelper from '../../host/WebMailHelper'
import SocialSharing from '../../host/SocialSharing'
import ReactDOMServer from 'react-dom/server'
import ButtonLinkExternal from '../../generic/ButtonLinkExternal'
import checkRequiredFields from '../../../helpers/check-required-fields';
import { hashToUri } from '../../../helpers/util';
import { STEPS } from '../Step'
export const moment = require('moment')

const Segment = styled.div`
  margin-bottom: 16px;
`

const Wrapper = styled.div`
  margin-bottom: 32px;
`

class HowToInvite extends Component {
  handleFocus(event) {
    event.target.select()
  }

  render() {
    const { userEvent, currentUser, guests, onChange } = this.props

    const eventURL = `${process.env.REACT_APP_BASE_URL}/event/${userEvent.token}`

    let formattedDate = null

    const blocked = !checkRequiredFields(STEPS['event'].requiredFields, userEvent, currentUser, {guests: guests})

    if (userEvent.invitation_date && typeof userEvent.invitation_date === 'string') {
      let dateComponents = userEvent.invitation_date.split("-")

      let date = new Date(dateComponents[0], dateComponents[1]-1, dateComponents[2])
      formattedDate = moment(date).format('dddd, MMMM D')
    }

    const message = [
      'Hello,',
      '',
      "I'll be hosting an On the Table event on " + (formattedDate ? formattedDate : "") + ", and would love if you could join in. The details and RSVP are found in the link below. If you have questions, just hit reply to write me back. I hope to see you there!",
      '',
      "Sincerely,",
      `${currentUser.firstname} ${currentUser.lastname}`,
      '',
      eventURL,
    ]

    let i = 0
    const invitationMessage = message.reduce((prev, curr) => { return [...prev, <br key={i++}/>, curr] }) // join(<br>)
    const invitationMessagePlainText = message.join("\n")
    const invitationMessageMailtoText = message.map((line) => encodeURIComponent(line)).join("%0A")

    const postcardParams = {
      food1: userEvent.food1 || '',
      food2: userEvent.food2 || '',
      topic: userEvent.topic || '',
      image: userEvent.invitation_logo || '',
    }

    return (
      <React.Fragment>
        <h1>Invite People</h1>

        {blocked &&
          <Tip id="invite-block" nodismiss="true">
            <p>Tools for inviting guests are available after you finish creating an invitation in Step 4.</p>
          </Tip>
        }

        <Blocker blocked={blocked}>
          <Wrapper>
            <Tip id="invite-initial">
              <p>Invite people by sending a link to the invitation page you built earlier. Use the tools on this page to invite people by email, sending a link by text, or posting to social media. <br/><strong>Only those who receive the link can see your invitation and RSVP.</strong></p>
            </Tip>

            <CollapsiblePanel title="Create an Invitation Email" showPrompt="Show" hidePrompt="Hide">
              <Segment>
                <Paragraph>Choose how you want to email guests, and we will create a message with your gathering details. You can customize the message before sending.</Paragraph>
                <Paragraph>To avoid confusion, we suggest inviting people from the same email address you used to sign up for On the Table.</Paragraph>
                <WebMailHelper event={userEvent} body={invitationMessageMailtoText} />
              </Segment>
            </CollapsiblePanel>

            <CollapsiblePanel title="Get Your Invitation Link" showPrompt="Show" hidePrompt="Hide">
              <Segment>
                <Paragraph>Paste this link in a text, Facebook, newsletter, or anywhere that you want to invite people.</Paragraph>
                <Row>
                  <ReadOnlyText type="text" readOnly style={{"display": "inline", background: 'white'}} value={eventURL} onFocus={this.handleFocus} />
                  <CopyToClipboardButton label="Copy Link" text={eventURL} style={{"display": "inline", "marginLeft": "10px"}} />
                </Row>
              </Segment>
            </CollapsiblePanel>

            <CollapsiblePanel title="Download Instagram-ready Postcard" showPrompt="Show" hidePrompt="Hide">
              <Segment>
                <p>A custom postcard image for sharing on Instagram, newsletters, emails. If you change your foods and/or topic, you can download an updated image.</p>
                <a href={`/api/image?${hashToUri({...postcardParams, dl: 1})}`}>
                  <div><img style={{ margin: '5px 0 10px', maxWidth: '50%' }} src={`/api/image?${hashToUri(postcardParams)}`}/></div>
                  <Button type="button">Download Image</Button>
                </a>
              </Segment>
            </CollapsiblePanel>

            <CollapsiblePanel title="Post to Social Media" showPrompt="Show" hidePrompt="Hide">
              <Segment>
                <Row>
                  <SocialSharing event={userEvent} fromHost="true" />
                </Row>
              </Segment>
            </CollapsiblePanel>
          </Wrapper>

          <Wrapper>
            <h1>More Invitation Tools</h1>

            <CollapsiblePanel title="Can We Share Your Conversation Topic?" showPrompt="Show" hidePrompt="Hide">
              <Segment>
                <p>We&#39;re looking for interesting ideas to share on social media as an example for others. Can you help by letting us share your combination?</p>
                  
                <Field name="userEvent[share_preferences]">
                  <div>
                    <RadioInput name="userEvent[share_preferences]" onChange={onChange} checked={parseInt(userEvent.share_preferences) === sharePreferences['NO']} value={sharePreferences['NO']} label="No, don't share my theme."/>
                  </div>
                  <div>
                    <RadioInput name="userEvent[share_preferences]" onChange={onChange} checked={parseInt(userEvent.share_preferences) === sharePreferences['ANON']} value={sharePreferences['ANON']} label="Yes, but keep me anonymous."/>
                  </div>
                  <div>
                    <RadioInput name="userEvent[share_preferences]" onChange={onChange} checked={parseInt(userEvent.share_preferences) === sharePreferences['YES']} value={sharePreferences['YES']} label="Yes, and attribute it to me/my organization."/>
                  </div>
                </Field>
                {parseInt(userEvent.share_preferences) === sharePreferences['YES'] && (
                  <React.Fragment>
                    <p style={{marginBottom: '20px'}}>Thank you! Please leave your Twitter and/or Instagram handle below so we can credit you.</p>
                    <Row className="twoCol">
                      <Field name="userEvent[twitter]" error={false}>
                        <Label value="Your Twitter Handle" />
                        <TextInput value={userEvent.twitter} label='' onChange={onChange} prepend={"@"} />
                      </Field>
                      <Field name="userEvent[instagram]" error={false}>
                      <Label value="Your Instagram Handle" />
                        <TextInput value={userEvent.instagram} onChange={onChange} prepend={"@"} />
                      </Field>
                    </Row>
                  </React.Fragment>
                )}
              </Segment>
            </CollapsiblePanel>
          </Wrapper>
        </Blocker>
      </React.Fragment>
    )
  }
}

export default HowToInvite

